<div *ngIf="data" class="drug-group-modal">
  <p><b>Group name: </b>{{data.userConfig.userDrugGroup.name}}</p>
  <p><b>Active ingredient: </b>
    {{data.userConfig.userDrugGroup.drugGroup.activeIngredientName}}
  </p>
  <p><b>Trade names: </b>
    <span *ngFor="let drug of data.userConfig.userDrugGroup.drugGroup.drugs; let isLast=last">{{drug.drugName}}{{isLast ? '' : ', '}}</span>
  </p>
</div>
